// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlyoutController from "./flyout_controller"
application.register("flyout", FlyoutController)

import AttendeesToggleController from "./attendees_toggle_controller"
application.register("attendees-toggle", AttendeesToggleController)

import PageToolsController from "../controllers/page_tools_controller"
application.register("page-tools", PageToolsController)

// Slide-out account sidebar on small screens (same controller as the gym app).
import MobileNavController from "../controllers/mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

// Right-side drawer (add family, link member) — same as admin invoice drawer.
import DrawerController from "../controllers/drawer_controller"
application.register("drawer", DrawerController)

// Reload memberships after Stripe Checkout until webhook lands.
import CheckoutReturnController from "../controllers/checkout_return_controller"
application.register("checkout-return", CheckoutReturnController)

// Pause duration radios + native date calendar (shared with gym console).
import MembershipPauseController from "../controllers/membership_pause_controller"
application.register("membership-pause", MembershipPauseController)
